module.exports = __webpack_public_path__ + "img/2.aad7ade0.jpg";